import React, {FormEvent} from 'react';
import Toggle from "components/Form/Toggle";
import {FormikHelpers} from "formik";
import {LoginFilter as LoginFilterSpec} from "types/AudienceCriteria";
import Field from "components/Form/Field";
import {setFilterDates} from "components/Form/CriteriaBuilder/Filters/Filter";

type Props = {
    formik: FormikHelpers<any>
    groupIndex: number
    filter?: LoginFilterSpec | null
}

function LoginFilter({formik, groupIndex, filter}: Props) {

    // Handle toggling this filter on and off
    const handleToggle = (checked: boolean): void => {
        formik.setFieldValue(
            `criteria.groups.${groupIndex}.filters.login`,
          checked ? {mode: "ever", dates: []} : undefined
        )
    }

    // Handling changing the date mode
    const handleChangeMode = (e: FormEvent<HTMLSelectElement>) => {
        formik.setFieldValue(`criteria.groups.${groupIndex}.filters.login.mode`, e.currentTarget.value)

        setFilterDates(formik,
            `criteria.groups.${groupIndex}.filters.login.dates`,
            e.currentTarget.value,
            filter?.dates || []
        )
    }

    return (
        <div className={!!filter? 'mt-6' : 'mt-8'}>
            <div className="flex items-center">
                <Toggle label="First logged-in" checked={!!filter} onChange={handleToggle} />

                {!filter && <span className="font-medium">...</span>}
            </div>

            {!!filter &&
                <div className="mt-2 pl-14 md:flex items-center">

                    {/* Mode */}
                    <div className="flex-shrink-0">
                        <Field as="select"
                               name={`criteria.groups.${groupIndex}.filters.login.mode`}
                               disabled={!filter}
                               onChange={handleChangeMode}>
                            <option value="ever">ever</option>
                            <option value="today">today</option>
                            <option value="tomorrow">tomorrow</option>
                            <option value="yesterday">yesterday</option>
                            <option value="this-week">this week</option>
                            <option value="next-week">next week</option>
                            <option value="last-week">last week</option>
                            <option value="on">on</option>
                            <option value="between">between</option>
                            <option value="before">before</option>
                            <option value="after">after</option>
                        </Field>
                    </div>

                    {/* Date 1 */}
                    <div className="mt-2 md:mt-0 md:ml-3 flex-shrink-0">
                        {['on', 'before', 'after', 'between'].includes(filter?.mode || '') &&
                            <Field type="date"
                                   name={`criteria.groups.${groupIndex}.filters.login.dates.0`}
                            />
                        }
                    </div>

                    {/* Date 2 */}
                    <div className="md:ml-3 md:flex items-center flex-shrink-0">
                        {['between'].includes(filter?.mode || '') &&
                            <>
                                <span className="ml-1 md:ml-0 md:mr-3">and</span>
                                <Field type="date"
                                       name={`criteria.groups.${groupIndex}.filters.login.dates.1`}
                                />
                            </>
                        }
                    </div>
                </div>
            }
        </div>
    );
}

export default LoginFilter;